import React from "react";
import { SbEditableBlok } from "@storyblok/storyblok-editable";
import { NavLinkV2, NavLinkV2Props } from "../../../atoms/NavLinkV2/NavLinkV2";

export interface FooterLinksBlockV2Props {
  blok: SbEditableBlok & {
    links: NavLinkV2Props["blok"][];
  };
}

export function FooterLinksBlockV2({ blok: { links,label } }: FooterLinksBlockV2Props) {
  return (
    <div className="space-y-3" aria-label={label}>
      {links?.length > 0 && links.map((linkBlok) => <NavLinkV2 key={linkBlok._uid} blok={linkBlok} />)}
    </div>
  );
}
